import styled from 'styled-components';
import {css} from 'styled-components';

export const Form = styled.form`
  @media (max-width: 500px) {
    width: 100%;
  }
  width: 50%;
  display: flex;
  flex-direction: column;
  input, textarea {
    margin-top: 24px;
  }
`;

export const TextArea = styled.textarea`
  border: 2px solid black;
  outline: 0;
  opacity: 0.6;
  height: 200px;
  transition: ease-in 0.1s;
  padding: 4px 6px;

  :focus {
    opacity: 1;
  }

  :placeholder-shown {
    cursor: text;
    top: 20px;
  }

  ${({isValidated}) =>
          !isValidated
                  ? css`
                    border: 2px solid red;

                    ::placeholder {
                      color: red;
                    }
                  `
                  : css`
                    border: 2px solid black; 
                    
                    ::placeholder {
                      color: black;
                    }
                  `}
  ${({isPending}) =>
          !isPending
                  ? css`
                    opacity: 1;
                    display: flex;
                  `
                  : css`
                    opacity: 0;
                    display: none;
                  `}
`;

export const TextInput = styled.input`
  border-bottom: 2px solid #000;
  opacity: 0.6;
  outline: 0;
  transition: ease-in-out 0.3s;
  padding: 4px 6px;
  :focus {
    opacity: 1;
  }
  :placeholder-shown {
    cursor: text;
    top: 20px;
  }
    ${({isValidated}) =>
    !isValidated
        ? css`
              border: 2px solid red;

              ::placeholder {
                color: red;
              }
        `
        : css`
              ::placeholder {
                color: black;
              }
        `}
  ${({isPending}) =>
    !isPending
        ? css`
              opacity: 1;
              display: flex;
        `
        : css`
              opacity: 0;
              display: none;
        `}
`;

export const Status = styled.div`
  margin: auto;
  width: 50%;
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
`;
